import Tabs, { Tab } from './Tabs';

export { Tabs as default, Tab };
